export type UmpireComponentType =
  | 'advertisement'
  | 'competition_season_statistics'
  | 'gallery'
  | 'header'
  | 'hero_main'
  | 'hero_thematic'
  | 'schedule'
  | 'match'
  | 'ott_hero_main'
  | 'group'
  | 'round'
  | 'social_media'
  | 'quiz'
  | 'iframe'
  | 'image'
  | 'news'
  | 'quotation'
  | 'text'
  | 'survey'
  | 'events'
  | 'product_list'
  | 'squad'
  | 'video'
  | 'branding'
  | 'page_header'
  | 'page_footer'
  | 'custom_link';
